import { ConfirmSaveModal } from 'components/common/index';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useEventWithDimensions from 'hooks/useEventWithDimensions';
import { useProjectTreeStore } from 'store/projectContract.store';
import { useMutationRefreshProgramAnalysisData } from 'api/mutations/refreshProgramAnalysisData.mutation';

export const ConfirmRefreshProjectModal = ({ handleModalClose, isShowModal }) => {
    const { project } = useProjectTreeStore();
    const { mutate, isLoading } = useMutationRefreshProgramAnalysisData();
    const { handleSnackBar } = useCustomSnackBar();
    const { sendEventWithDimensions } = useEventWithDimensions();

    const handleRefreshProject = () => {
        mutate(
            { projectIDs: project?.id ? [project?.id] : [] },
            {
                onSuccess: () => {
                    handleSnackBar('Refresh started. Please wait for re-upload to complete', 'success');

                    sendEventWithDimensions({
                        category: 'Program Library',
                        action: 'Refresh Project',
                        label: project?.title,
                    });
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => handleModalClose(),
            },
        );
    };

    return (
        <ConfirmSaveModal
            isShowModal={isShowModal}
            onHideModal={handleModalClose}
            onConfirm={handleRefreshProject}
            isLoading={isLoading}
            actionButtonLabel={'Refresh'}
        >
            Are you sure you want to refresh this project ({project?.title})?
        </ConfirmSaveModal>
    );
};
